// Based on .env VITE_ENV_MODE
export const PRODUCTION_ENVS = ["staging", "platform"];
export const TEST_STAGING_ENV_MODE = "test";
export const TEST_DEV_ENV_MODE = "test-dev";
export const DEV_ENV_MODE = "development";

export type FlagName =
  | "FEATURE_TOUR"
  | "DASHBOARD_OVERVIEW_CUSTOMER"
  | "CUSTOMERS_TABLE_TYPE_COLUMN"
  | "PHS_CUSTOMER_SEND_TEST_LURE"
  | "SEG_CHECKBOX"
  | "MSP_BRANDING"
  | "CYBERSENTRIQ_ANNOUNCEMENT_MODAL"
  | "INCIDENTS_V3_CATEGORIES"
  | "MSP_OVERVIEW_CHART"
  | "SAT_QUIZ"
  | "LOGOUT_WITH_REDIRECT"
  | "DASHBOARD_EMAIL_ARCHIVING_CARD"
  | "INCIDENTS_INCLUDE_ATTACHMENTS"
  | "QUARANTINE_ACTIONS"
  | "QUARANTINE_REFRESH_BUTTON"
  | "EXEMPTIONS"
  | "BLOCK_LIST_API"
  | "EMAIL_HISTORY";

type Config = {
  [K in FlagName]: {
    dev: boolean;
    testDev: boolean;
    testStaging: boolean;
    prod: boolean;
  };
};

export const FLAGS_CONFIG: Config = {
  FEATURE_TOUR: {
    dev: false,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  DASHBOARD_OVERVIEW_CUSTOMER: {
    dev: false,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  CUSTOMERS_TABLE_TYPE_COLUMN: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1706
  PHS_CUSTOMER_SEND_TEST_LURE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1956
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1957
  SEG_CHECKBOX: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2593
  MSP_BRANDING: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1240
  INCIDENTS_V3_CATEGORIES: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  CYBERSENTRIQ_ANNOUNCEMENT_MODAL: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2656
  MSP_OVERVIEW_CHART: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/2439
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/2440
  SAT_QUIZ: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  LOGOUT_WITH_REDIRECT: {
    dev: false,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/3572
  DASHBOARD_EMAIL_ARCHIVING_CARD: {
    dev: true,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2690
  INCIDENTS_INCLUDE_ATTACHMENTS: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2961
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/3023
  QUARANTINE_ACTIONS: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2841
  QUARANTINE_REFRESH_BUTTON: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2858
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2859
  EXEMPTIONS: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/3040
  BLOCK_LIST_API: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/3131
  EMAIL_HISTORY: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
};
